import { render } from "./VehicleReportPrintCanceledTable.vue?vue&type=template&id=0ddeec35&ts=true"
import script from "./VehicleReportPrintCanceledTable.vue?vue&type=script&lang=ts"
export * from "./VehicleReportPrintCanceledTable.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./VehicleReportPrintCanceledTable.vue?vue&type=style&index=0&id=0ddeec35&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTr,QTh});
